<template>
  <div class="sidebar"
       :data-color="backgroundColor"
       >
    <div class="sidebar-wrapper" style="background:black;">
      <div class="logo" style="background:#393D49;font-size:30px">
        <a href="#" class="simple-text logo__container" style="font-size:14px">
            <!-- <div class="logo-img">
                <img src="../../../public/img/vue-logo.png" alt="">
            </div> -->
          {{title}}
        </a>
      </div>

      <slot name="contentt"></slot>
      <ul class="nav nav-main__links">
        <slot>
          <sidebar-link v-for="(link,index) in sidebarLinks"
                        :key="link.name + index"
                        :to="link.path"
                        @click="closeNavbar"
                        :link="link">
            <i :class="link.icon"></i>
            <p>{{link.name}}</p>
          </sidebar-link>
        </slot>
      </ul>
      <ul class="nav nav-bottom" v-if="$slots['bottom-links']">
        <slot name="bottom-links"></slot>
      </ul>
    </div>
  </div>
</template>
<script>
  import SidebarLink from './SidebarLink.vue'

  export default {
    components: {
      SidebarLink
    },
    props: {
      title: {
        type: String,
        default: '会议学术服务平台'
      },
      backgroundColor: {
        type: String,
        default: 'black'
      },

      activeColor: {
        type: String,
        default: 'success',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    provide () {
      return {
        autoClose: this.autoClose
      }
    },
    computed: {

    }
  }

</script>
<style>
  .sidebar .sidebar-wrapper {
    display: flex;
    flex-direction: column;
  }
 .sidebar .nav-main__links {
   flex: 1;
 }
 .sidebar .sidebar-wrapper .logo .logo__container {
   padding-left: 10px;
 }
</style>
